import { h } from 'preact';
import * as BaseComp from 'components/pages/projects/projects.js';
import { sortObjectByOrder } from 'utils/utils';
import Grid from 'components/shared/grid/grid';
import { joinClasses } from 'utils/utils';
import s from 'components/pages/projects/projects.sss';

export default class Projects extends BaseComp.default {
	constructor(props) {
		super();
		this.state = {
			projects: props.activePage.data.copy.projects,
			search: [],
		};
	}

	handleClick(category) {
		const { search } = this.state;
		const index = search.indexOf(category);
		if (index !== -1) {
			search.splice(index, 1);
		} else {
			search.push(category);
		}
		this.setState({ search: search });
	}

	categoryMenu(categories) {
		const isActive = (categoryName) => {
			if (this.state.search.includes(categoryName)) {
				return s.active;
			}
		};

		return (
			<div class={s.categories}>
				<h1 class={s.categoryTitle}>Categories</h1>
				<ul class={s.list}>
					{
						categories.map(c => {
							const className = c.categoryName.toLowerCase().replace(/\s/g, '');
							return (
								<li class={s.listItem} onClick={() => this.handleClick(c.categoryName)}>
									<p class={joinClasses(s.name, s[className], isActive(c.categoryName))}>{c.categoryName}</p>
								</li>
							);
						})
					}
				</ul>
			</div>
		);
	}

	render({ pageData, appData }) {
		let {
			copy: pageCopy,
			background,
			allowBgVideo,
			...baseConfig
		} = pageData;
		const { copy } = appData;
		const imageRoot = appData.urls.roots.image;

		const sortedProjects = sortObjectByOrder(this.state.projects, (val, key) => ({ ...val, key }));

		const { search } = this.state;
		const filteredSortedProjects = search.length ? sortedProjects.filter(project => {
			if (search.includes(project.category.toLowerCase())) {
				return project;
			}
		}) : sortedProjects;

		const categories = sortObjectByOrder(pageCopy.categories);

		return (
			<div class={joinClasses(s.wrapper, this.props.id && 'page-component-' + this.props.id)}>
				<Grid
					dataObj={filteredSortedProjects}
					baseConfig={baseConfig}
					copy={copy}
					imageRoot={imageRoot}
					subtitle={pageCopy.subtitle}
					imageSrc={pageData.imageSrc}
					title={pageCopy.title}
					menu={this.categoryMenu(categories)}
					pageId={this.props.id}
				/>
			</div>
		);
	}
}

export const verticallyCenter = BaseComp.verticallyCenter;
export const dependencies = BaseComp.dependencies;
